var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h3',[_vm._v(_vm._s(_vm.JSONParseTranslations(_vm.area.title, _vm.locale.key)))]),_c('q-btn',{staticClass:"plus-btn",attrs:{"icon":"add","text-color":"primary","size":"26px","flat":"","dense":"","to":{
            name: 'Courses',
            params: {
                areaId: _vm.area.id,
            },
        }}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }